<template>
  <main-template>
    <div style="padding-bottom: 5%">
      <div>
        <v-row>
          <v-card-title class="font-weight-black">Painel de indicadores</v-card-title>
        </v-row>

        <v-row>
          <e-unidades-card />
          <e-turmas-card />
          <e-matriculas-card />
          <e-taxa-ocupacao-card />
        </v-row>

        <v-row>
          <v-card-title class="font-weight-black">Alunos</v-card-title>
        </v-row>

        <v-row>
          <e-zona-card />
          <e-genero-card />
          <e-cor-ou-raca-card :franquiaId="franquiaId" />
          <e-deficientes-card />
        </v-row>

        <v-row>
          <v-card-title class="font-weight-black">Professores</v-card-title>
        </v-row>

        <v-row>
          <e-quantidade-professores-card />
          <e-professor-vinculo-card />
          <e-professor-genero-card />
          <e-professor-deficientes-card />
        </v-row>
      </div>

      <v-row style="margin-bottom: -30px">
        <v-col cols="12 mt-4">
          <e-label>Pesquise uma unidade escolar aqui</e-label>
          <e-autocomplete
            :items="franquiasListInfo"
            :return-object="false"
            :item-value="(value) => value"
            :item-text="(value) => value.descricao"
            v-model="franquiaSelecionada"
            label="Selecione uma opção"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-card-title class="font-weight-black">Resumo unidade</v-card-title>
      </v-row>

      <v-row class="mt-2">
        <e-matriculas-unidade-card :franquiaId="franquiaId" />
        <e-aulas-lancadas-card :franquiaId="franquiaId" />
        <e-aulas-confirmadas-lancadas-card :franquiaId="franquiaId" />
        <e-taxa-evasao-card :franquiaId="franquiaId" />
      </v-row>

      <v-row>
        <e-faixa-etaria-card :franquiaId="franquiaId" />
        <v-col cols="12">
          <v-card outlined class="mx-auto mt-2">
            <apexchart type="line" height="400" :options="options" :series="series"></apexchart>
          </v-card>
        </v-col>
        <v-col v-if="usuarioEhAdministrador" cols="12">
          <v-card outlined class="mx-auto mt-2">
            <apexchart
              type="line"
              height="400"
              :options="aulasMunicipio"
              :series="dadosMunicipio"
            ></apexchart>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";

const MESES = ["Jan", "Fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];

export default {
  name: "HomePage",
  async created() {
    await this.$services.franquiasService.syncAll();
    await this.loadData();
    this.franquiaId = this.user.franquia.id;
    this.selecionarFranquiaAtual();
    await this.graficoDeAulasPorEscola();
    await this.graficoDeAulasDoMunicipio();
  },
  data() {
    return {
      franquiaSelecionada: null,
      franquiaId: null,
      franquiasListInfo: [],
      max: 100,
      maxMunicipio: 100,
      options: this.montarOptions("Grafico de notas da escola atual", 500),
      aulasMunicipio: this.montarOptions("Grafico de notas da escola atual", 500),
      series: this.montarSeriesDeAulas(),
      dadosMunicipio: this.montarSeriesDeAulas(),
    };
  },

  computed: {
    ...mapGetters("Auth", ["user"]),

    usuarioEhAdministrador() {
      return this.user.roles.some((role) => role.name === "super-admin" || role.name === "admin");
    },
  },

  watch: {
    user() {
      this.franquiaId = this.user.franquia.id;
      this.selecionarFranquiaAtual();
      this.graficoDeAulasPorEscola();
    },

    async franquiaSelecionada(value) {
      if (value && value.id !== this.user.franquia.id) {
        try {
          const ip_do_usuario = await this.$services.webInfo.pegarIpLocalDoUsuario();
          const dispositivo_do_usuario = this.$services.webInfo.pegarDispositivoDoUsuario();
          await this.$services.authService.mudarDeFranquia(
            this.franquiaSelecionada,
            ip_do_usuario,
            dispositivo_do_usuario
          );
          this.$toast.success("Unidade escolar alterada com sucesso!");
        } catch (error) {
          this.$handleError(error);
        }
      }
    },

    max(value) {
      this.options = this.montarOptions("Gráfico de aulas da escola atual", value);
    },

    maxMunicipio(value) {
      this.aulasMunicipio = this.montarOptions(
        "Gráfico de aulas de todas as escolas do município",
        value
      );
    },
  },

  methods: {
    selecionarFranquiaAtual() {
      if (!this.user || !this.user.franquia) return;

      const franquiaAtual = this.franquiasListInfo.find(
        (franquia) => franquia.id === this.user.franquia.id
      );
      if (franquiaAtual) this.franquiaSelecionada = franquiaAtual;
    },

    montarOptions(titulo, max) {
      return {
        chart: {
          foreColor: "#263238",
          height: 350,
          type: "line",
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: true,
          },
        },
        stroke: {
          width: [0, 4],
        },
        plotOptions: {
          bar: {
            columnWidth: "35%",
            endingShape: "rounded",
          },
        },
        colors: ["#0d6efd", "#212529"],
        title: {
          text: titulo,
          style: {
            fontSize: "16px",
            fontWeight: "bold",
            fontFamily: undefined,
            color: "#263238",
          },
        },
        dataLabels: {
          enabled: true,
          enabledOnSeries: [1],
        },
        labels: [...MESES],
        yaxis: [
          {
            title: {
              text: "Lançadas",
            },
            max,
          },
          {
            opposite: true,
            title: {
              text: "Confirmadas",
            },
            max,
            logarithmic: false,
            logBase: 10,
            floating: false,
          },
        ],
      };
    },

    montarSeriesDeAulas(
      lancadas = [100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100],
      confirmadas = [23, 42, 35, 27, 43, 22, 17, 31, 22, 22, 12, 16]
    ) {
      return [
        {
          name: "Aulas lançadas",
          type: "column",
          data: lancadas,
        },
        {
          name: "Aulas confirmadas",
          type: "line",
          data: confirmadas,
        },
      ];
    },

    async loadData() {
      this.$loaderService.open("Carregando dados");
      this.franquiasListInfo = await this.$services.franquiasService.countInfoHome();
      this.$loaderService.close();
      this.$forceUpdate();
    },

    async graficoDeAulasPorEscola() {
      const response = await this.$services.aulasService.graficoDeAulasLancadasEConfirmadas(
        this.franquiaId
      );
      if (response.data.length !== 0) {
        const lancadas = response.data.aulasLancadas.map((a) => a.total);
        const confirmadas = response.data.aulasConfirmadas.map((a) => a.total);

        this.series = this.montarSeriesDeAulas(lancadas, confirmadas);
        this.max = Math.max(...lancadas);
      }
    },

    async graficoDeAulasDoMunicipio() {
      const response =
        await this.$services.aulasService.graficoDeAulasLancadasEConfirmadasDoMunicipio();
      if (response.data.length !== 0) {
        const lancadas = response.data.aulasLancadas.map((a) => a.total);
        const confirmadas = response.data.aulasConfirmadas.map((a) => a.total);

        this.dadosMunicipio = this.montarSeriesDeAulas(lancadas, confirmadas);
        this.maxMunicipio = Math.max(...lancadas);
      }
    },
  },
};
</script>
